export class ValidationService {
  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    let config = {
      'required': 'This field is required',
      'invalidExpireDateFormat': 'The expire date format is not correct!\n',
      'expireHasPassed': 'The expiry date has passed.\n',
      'invalidCardMember': 'Invalid Card Member',
      'invalidNumber': 'Invalid number',
      'invalidPhoneNumber': 'invalid Australian phone number',
      'invalidCreditCard': 'Is invalid credit card number',
      'invalidEmailAddress': 'Invalid email address',
      'invalidPassword': 'Invalid password. Password must be at least 8 characters long, and contain a number.',
      'minlength': `Minimum length ${validatorValue.requiredLength}`
    };

    return config[validatorName];
  }

  static creditCardValidator(control) {
    if (control.value && control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
      return null;
    } else {
      return {'invalidCreditCard': true};
    }
  }

  static emailValidator(control) {
    if (control.value && control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
      return null;
    } else {
      return {'invalidEmailAddress': true};
    }
  }

  static passwordValidator(control) {
    if (control.value && control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,100}$/)) {
      return null;
    } else {
      return {'invalidPassword': true};
    }
  }

  static numberValidator(control) {
    if (control.value && control.value.match(/^\d{4,6}$/)) {
      return null;
    } else {
      return {'invalidNumber': true};
    }
  }

  static australianPhoneNumber(control) {
    let phoneExpression = /^\({0,1}((0|\+61)(2|4|3|7|8)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/;
    if (control.value && control.value.match(phoneExpression)) {
      return null;
    } else {
      return {'invalidPhoneNumber': true};
    }
  }

  static cardMember(control) {
    let phoneExpression = /^\d{4}$/;
    if (control.value && control.value.match(phoneExpression)) {
      return null;
    } else {
      return {'invalidCardMember': true};
    }
  }

  static expiryDate(control) {
    let expire = control.value;
    if (expire && !expire.match(/(0[1-9]|1[0-2])[-][0-9]{2}/)) {
      return {'invalidExpireDateFormat': true};
    } else if (expire) {
      let d = new Date();
      let currentYear = d.getFullYear();
      let currentMonth = d.getMonth() + 1;
      let parts = expire.split('-');
      let year = parseInt(parts[1], 10) + 2000;
      let month = parseInt(parts[0], 10);
      if (year < currentYear || (year == currentYear && month < currentMonth)) {
        return {'expireHasPassed': true};
      } else {
        return null;
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/services/validation.service.ts